import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { setSessionLostHandler } from './lib/bounce';
import { queryKeys } from './lib/queryKeys';
// components.css FIRST, deliberately — see the cascade note at the top of that file. It
// carries the demos' component classes, which must land BEFORE `@tailwind utilities` (which
// styles.css emits) so a utility of equal specificity always wins.
import './components.css';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root is missing from index.html');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

// A session refused mid-visit must not leave a rendered screen behind: re-ask the server who
// we are, get the 401, and let the route guard take the person to sign-in.
// `resetQueries`, not `invalidateQueries`: a failed BACKGROUND refetch keeps the last good
// data, so an invalidation alone would leave a dead session still looking signed in. A reset
// empties it first, then re-asks — and the 401 that comes back is what moves the guard.
setSessionLostHandler(() => {
  void queryClient.resetQueries({ queryKey: queryKeys.me });
});

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
